import { api } from "@api/api";
import { DefaultPlan } from "@modules/defaultPlans/types";
import { DefaultPlanFormValues } from "@modules/defaultPlans/validations";

export async function createDefaultPlanService(data: DefaultPlanFormValues): Promise<DefaultPlan> {
  const { data: defaultplan } = await api.post<DefaultPlan>("v1/default_plan_admin/", data);

  return defaultplan;
}
